export default __webpack_public_path__ + "static/media/horse.497d0614.png";